export const PageRefLink = ({
  file,
  page,
  label,
  onNavigate,
}: {
  file: string;
  page: number;
  label?: string;
  onNavigate: (file: string, page: number) => void;
}) => {
  return (
    <button
      type="button"
      className="inline-flex items-center text-xs text-blue-600 hover:text-blue-800 hover:underline font-medium"
      onClick={(e) => {
        e.stopPropagation();
        onNavigate(file, page);
      }}
      title={`${file} p.${page}`}
    >
      {label ?? `p.${page}`}
    </button>
  );
};
